export const checkLiveOrNotGet = (data) => {
    return data.data;
}
export const customerWorkStatusSave = (data) => {
    return data.data;
}